import type { FC } from 'react';
import { useFormikContext } from 'formik';

import * as Core from 'components/core';
import { Values } from './types';
import { useTranslation } from 'react-i18next';

interface Props {}

const StudentLicenseDetails: FC<Props> = () => {
  const { t } = useTranslation(['translation', 'checkout']);
  const { values, handleChange, handleBlur } = useFormikContext<Values>();

  return (
    <>
      <h2>{t('payment.studentLicense.heading', { ns: 'checkout' })}</h2>

      <Core.InputFormGroup
        name="studentInstitutionName"
        value={values.studentInstitutionName}
        label={t('payment.studentLicense.institution', { ns: 'checkout' })}
        testID="licensee-student-institution-field"
        required
        onChange={handleChange}
        onBlur={handleBlur}
      />

      <Core.InputFormGroup
        name="studentProgramName"
        value={values.studentProgramName}
        label={t('payment.studentLicense.program', { ns: 'checkout' })}
        testID="licensee-student-program-field"
        onChange={handleChange}
        onBlur={handleBlur}
      />

      <Core.Checkbox
        name="studentEnrolled"
        value={values.studentInstitutionName}
        testID="licensee-student-verify-enrolled-checkbox"
        onChange={handleChange}
        required
      >
        {t('payment.studentLicense.verifyEnrolled', { ns: 'checkout' })}
      </Core.Checkbox>
    </>
  );
};

export default StudentLicenseDetails;
